import { BTN_TYPES } from "@/utils/constants";
import React from "react";

function Button({
  onClickFn,
  btnType = BTN_TYPES.PRIMARY,
  children,
  disabled = false,
  customClasses,
  refs = null,
  onMouseEnter,
  onMouseLeave,
}) {
  const btnClass =
    btnType === BTN_TYPES.PRIMARY ? "btn-primary" : "btn-secondary";

  return (
    <button
      className={`group ${btnClass} ${customClasses}`}
      onClick={onClickFn}
      disabled={disabled}
      ref={refs}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
}

export default Button;

/*
================================================
Button Component Usage 
================================================

import { Button } from "@/components/common";
import { BTN_TYPES } from "@/utils/constants";


<Button
  onClickFn={onClickCallabackFunction}
  btnType={BTN_TYPES.PRIMARY || BTN_TYPES.SECONDARY}
>
  // button content and its hover states
  <div className="text-primary group-hover:text-white group-disabled:text-disabled">
    Reserve Your Matic
  </div>
</Button>

*/
